import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2174e6f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-7" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clockin-details-container" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Clock-In Details")
], -1))
const _hoisted_6 = { class: "clockin-details-grid" }
const _hoisted_7 = { class: "table table-bordered plusmetric-summary clockin-print" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"27px"} }),
  /*#__PURE__*/_createElementVNode("col"),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"20%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"20%"} })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "heading" }),
    /*#__PURE__*/_createElementVNode("th", { class: "heading" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "heading" }, "Shift Start Time"),
    /*#__PURE__*/_createElementVNode("th", { class: "heading" }, "Clock-In Time")
  ])
], -1))
const _hoisted_10 = { class: "clockInStatusGroupRow grouping-row" }
const _hoisted_11 = { colspan: "4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "group-cell" }, null, -1))
const _hoisted_13 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isShowClockInContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("table", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _createElementVNode("tbody", null, [
                  (_ctx.clockInDataList != null && _ctx.clockInDataList.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.clockInDataList, (clock) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: clock }, [
                          _createElementVNode("tr", _hoisted_10, [
                            _createElementVNode("td", _hoisted_11, [
                              _createElementVNode("p", null, _toDisplayString(clock.clockedInGroupText), 1)
                            ])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clock.clockInList, (dataItem) => {
                            return (_openBlock(), _createElementBlock("tr", { key: dataItem }, [
                              _hoisted_12,
                              _createElementVNode("td", {
                                title: dataItem.name
                              }, _toDisplayString(dataItem.name), 9, _hoisted_13),
                              _createElementVNode("td", null, _toDisplayString(dataItem.beginningShift), 1),
                              _createElementVNode("td", null, _toDisplayString(dataItem.actualTimeIn), 1)
                            ]))
                          }), 128))
                        ], 64))
                      }), 128))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}